import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { filter } from 'rxjs/operators';
import { FormControl, Validators } from '@angular/forms';
import { Authentication } from '../../services/authentication.service';
import { ErrorHandlingService } from '../../services/error-handling.service';
import { NotificationService } from '../../services/notification.service';
import { AccountService } from '../../services/account.service';
import { TitleService } from '../../services/title.service';

@Component({
  standalone: false,
  selector: 'app-password-reset',
  templateUrl: './password-reset.component.html',
  styleUrls: ['./password-reset.component.css'],
})
export class PasswordResetComponent implements OnInit {
  token: any;
  username: any;
  password: any;
  isTokenExpired = false;
  show_eye = false;

  emailFC = new FormControl('', [Validators.required, Validators.email]);
  passwordFC = new FormControl('', [Validators.required]);

  constructor(
    private authService: Authentication,
    private accountService: AccountService,
    private router: Router,
    private route: ActivatedRoute,
    private ngxLoader: NgxUiLoaderService,
    private titleService: TitleService,
    private errorHandlingService: ErrorHandlingService,
    private notificationService: NotificationService,
  ) {
    this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe(() => {
      this.setTabTitle();
    });
    this.route.queryParams.subscribe((params) => {
      this.username = params['username'];
      this.token = params['token'];
      if (this.token && !this.token.startsWith('test')) {
        this.isTokenExpired = !this.authService.isTokenValid(this.token);
      }
    });
    if (this.authService.isTokenValid()) {
      this.router.navigate(['automap']);
    }
  }
  setTabTitle() {
    this.titleService.setTitle(this.route.snapshot, this.router.routerState.snapshot);
  }
  onSubmit() {
    this.ngxLoader.start();
    this.username = this.emailFC.value;
    this.password = this.passwordFC.value;
    if (this.token === '' || this.token === undefined || this.token === null || this.isTokenExpired) {
      if (!this.username || this.username == '') {
        this.errorHandlingService.showError('Please enter your email!');
        this.ngxLoader.stop();
        return;
      }
      this.accountService.reset(this.username).subscribe(
        (data) => {
          this.ngxLoader.stop();
          this.notificationService.showSuccess('Password email sent successfully');
          this.router.navigate(['/email-reset-password'], {
            queryParams: { username: this.username },
          });
        },
        (err) => {
          this.ngxLoader.stop();
          this.errorHandlingService.handleError(err, err.url);
        },
      );
    } else {
      // Set the access token for this call (should get reset on login)
      localStorage.setItem('access_token_automap', this.token);
      this.accountService.validateAccountToken(this.username).subscribe(
        (data) => {
          this.notificationService.showSuccess('Account token validated');

          // Set the access token for this call (should get reset on login)
          localStorage.setItem('access_token_automap', this.token);
          this.accountService.resetPassword(this.username, this.password).subscribe(
            (data) => {
              this.ngxLoader.stop();
              this.notificationService.showSuccess('Password reset successfully');
              // Remove the token before login redirect, we need a new kind of token
              localStorage.removeItem('access_token_automap');
              this.router.navigate(['login'], {
                queryParams: { username: this.username },
              });
            },
            (err) => {
              this.ngxLoader.stop();
              this.errorHandlingService.handleError(err, err.url);
            },
          );
        },
        (err) => {
          this.ngxLoader.stop();
          this.errorHandlingService.showError('Unauthorized: Invalid token');
          this.errorHandlingService.handleError(err, err.url);
        },
      );
    }
  }

  showPassword(show) {
    this.show_eye = show;
  }

  ngOnInit(): void {
    this.setTabTitle();
    this.username = this?.route?.snapshot?.queryParamMap?.get('username');
    this?.emailFC?.setValue(this?.username);
  }

  navigate() {
    window.location.href = 'https://www.terminologyhub.com';
  }
}
